'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = CheckboxField;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _formComponents = require('components/formComponents');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CheckboxField(props) {
  return _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({ component: _formComponents.formCheckbox }, props, { normalize: function normalize(val) {
      return val ? 1 : 0;
    } }));
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/formComponents/CheckboxField.js
// module id = 523
// module chunks = 1